import { useToast } from '@frontend/ui-library';
import { getIdFromUrl } from '@frontend/utils';
import { useState } from 'react';
import { MethodApiId } from '../data/methods';
import useSelectCurrency from './useSelectCurrency';
import { PaymentMethod } from '../graphql/customTypes';

interface UseCurrencySubmissionProps {
  onSelectionError: () => void;
  onSelectionComplete?: () => void;
}

export const useCurrencySubmission = ({
  onSelectionError,
  onSelectionComplete,
}: UseCurrencySubmissionProps) => {
  const [loading, setLoading] = useState(false);
  const { selectCurrency } = useSelectCurrency();
  const toast = useToast();

  interface SubmitCurrencySelectionProps {
    currency: string;
    network: string;
    methodId: MethodApiId;
    paymentMethod: PaymentMethod;
  }

  const submitCurrencySelection = async ({
    currency,
    network,
    methodId,
    paymentMethod,
  }: SubmitCurrencySelectionProps) => {
    try {
      toast.close();
      setLoading(true);
      const { data } = await selectCurrency({
        variables: {
          methodId,
          blockchain: network,
          currency: currency,
          type: 'bill',
          id: getIdFromUrl(),
          paymentMethod,
        },
      });

      if (data?.selectCurrency?.__typename === 'ErrorPage') {
        toast.open({
          title: 'Error',
          status: 'error',
          message: data.selectCurrency.pageData.info || '',
        });
        onSelectionError();
      }
    } catch (e) {
      toast.open({
        title: 'Something went wrong',
        message: 'Please try again later',
        status: 'error',
      });
      onSelectionError();
    } finally {
      setLoading(false);
      onSelectionComplete?.();
    }
  };

  return {
    loading,
    submitCurrencySelection,
  };
};
